import React from "react";
import { Link } from "react-router-dom";
import { LogoProps } from "../../interfaces/props/LogoProps/LogoProps";
import { LogoImage } from "../LogoImage/LogoImage";

import classes from "./Logo.module.css";

export function Logo(props: LogoProps) {
  const { className = "", to, href = "/", isMarkOnly = false } = props;
  const combinedClassName = `${classes.logoLink} ${className}`.trim();

  if (to) {
    return (
      <Link className={combinedClassName} to={to}>
        <LogoImage isMarkOnly={isMarkOnly} />
      </Link>
    );
  }

  return (
    <a className={combinedClassName} href={href}>
      <LogoImage isMarkOnly={isMarkOnly} />
    </a>
  );
}
